'use client';

import { useQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

import type { FilterOption } from '../../constants';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { FilterChipGroup } from '../FilterChipGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';

interface DonationFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  institutionIds: number[];
  onToggleInstitution: (id: number) => void;
  onReset: () => void;
}

export function DonationFilter({
  isDrawerOpen,
  onCloseDrawer,
  onApplyDrawer,
  institutionIds,
  onToggleInstitution,
  onReset,
}: DonationFilterProps) {
  const { data: institutionOptions = [], isLoading: isInstitutionLoading } = useQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/home/institution/for-search-filter'
    ]({
      query: { institutionFilterType: 'BUSINESS' },
    }),
    staleTime: Infinity,
    gcTime: Infinity,
    select: ({ context }): FilterOption<number>[] =>
      (context?.contents ?? [])
        .filter((item) => Boolean(item.institutionName))
        .map((item) => ({
          value: item.institutionId,
          label: item.institutionName,
        })),
  });

  return (
    <>
      <FilterSidebarShell onReset={onReset}>
        <FilterSection title="지자체">
          <FilterCheckboxList
            options={institutionOptions}
            selectedValues={institutionIds}
            onToggle={onToggleInstitution}
            isLoading={isInstitutionLoading}
            skeletonCount={12}
          />
        </FilterSection>
      </FilterSidebarShell>

      <FilterDrawerShell
        isOpen={isDrawerOpen}
        onReset={onReset}
        onApply={onApplyDrawer}
        onClose={onCloseDrawer}
      >
        <div className="flex flex-col gap-12">
          <h3 className="font-700 text-Gray-900 typo-body4">지자체</h3>
          <FilterChipGroup
            options={institutionOptions}
            selectedValues={institutionIds}
            onToggle={onToggleInstitution}
            isLoading={isInstitutionLoading}
            skeletonCount={12}
          />
        </div>
      </FilterDrawerShell>
    </>
  );
}
